export const DEFAULT_CRM_TOKEN = 'nr0w5ovs5hm';
/** Placeholder: replace with agency CRM chromeless app URL when available (portal.md leaves this blank) */
export const CRM_APP_IFRAME_URL = 'https://agency.comcate.com/';
export const brandLogo = `${window.assetsLocation}/images/logo.png`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/brand.png`;
export const textLogoUrl = `${window.assetsLocation}/images/logo.png`;
export const secondaryLogoUrl = `${window.assetsLocation}/images/logo_.png`;
export const bannerUrl = `${window.assetsLocation}/images/banner.png`;
export const bannerMobileUrl = `${window.assetsLocation}/images/banner.png`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const twitterXIcon = `${window.assetsLocation}/images/x.svg`;
export const homeArticleIds = ['17'];
export const faqArticleIds = ['3', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16'];
